import React from "react";
import NavBar from "../components/NavBar";
import { useLocation } from "react-router-dom";
import { Backdrop, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function Layout({ children }) {
  const location = useLocation();
  const { post_schedules_loading, delete_schedules_loading } = useSelector(
    (state) => state.user
  );
  const { email, getUserLoading, fetched } = useSelector(
    (state) => state.trello
  );
  const pathname =
    location.pathname.includes("menu") || location.pathname.includes("auth");
  const openBackdrop = post_schedules_loading || delete_schedules_loading;

  return (
    <div className="mx-auto w-100">
      {!pathname && !getUserLoading && email && fetched && <NavBar />}
      {children}
      {openBackdrop && (
        <Backdrop sx={{ color: "#FFF", zIndex: 9999 }} open={openBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
}

export default Layout;
